import { render } from "./Settings.vue?vue&type=template&id=1fb7c71a&scoped=true&ts=true"
import script from "./Settings.vue?vue&type=script&lang=ts"
export * from "./Settings.vue?vue&type=script&lang=ts"

import "./Settings.vue?vue&type=style&index=0&id=1fb7c71a&scoped=true&lang=css"

import exportComponent from "/Users/asaskevich/Work/sequoia-cabinet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb7c71a"]])

export default __exports__